import { AssessmentTypeRecommendationEngineRegistry } from './AssessmentTypeRecommendationEngineRegistry';
import { MraRecommendationEngine } from './MraRecommendationEngine';

export const assessmentTypeRecommendationEngineRegistry = new AssessmentTypeRecommendationEngineRegistry();
assessmentTypeRecommendationEngineRegistry.register(new MraRecommendationEngine());
